import Layout from '@components/layout';
import PageEntranceAnimation from '@components/page-entrance-animation';
import DuelanaGames from '@modules/home-page/duelana-games';
import DuelanaSlider from '@modules/home-page/duelana-slider';
import DuelanaTops from '@modules/home-page/duelana-tops';

const views: JSX.Element[] = [
    <DuelanaSlider key={0} />,
    <DuelanaGames key={1} />,
    <DuelanaTops key={2} />,
];

const HomePage = (): JSX.Element => {
    return (
        <Layout>
            <PageEntranceAnimation modules={views} fetched />
        </Layout>
    );
};

export default HomePage;
